import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import Shimmer from '@vfgroup-oneplatform/foundation/Components/Shimmer';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';
import {
  subTrayCardsLoadingConfig as _subTrayCardsLoadingConfig,
  shimmerPlaceholderConfig as _shimmerPlaceholderConfig,
} from '../Config/LoadingConfig';

import styles from './Loading.styles';

const Loading = props => {
  const { subTrayCardsLoadingConfig, shimmerPlaceholderConfig, theme } = props;
  const loadingCards = [];
  for (let i = 0; i < 3; i++) {
    const loadingCard = (
      <View
        style={styles.containerStyle(theme)}
        key={`Loading-Card-${i}`}
        testID={FrameworkTestKeys.trayLoadingCardView}
      >
        <View style={styles.loadingCard(theme)} testID={FrameworkTestKeys.trayLoadingCardMainView}>
          <View
            style={styles.firstLineContainer}
            testID={FrameworkTestKeys.trayLoadingCardFirstLineView}
          >
            <Shimmer
              config={subTrayCardsLoadingConfig.firstLine}
              shimmerPlaceholderConfig={shimmerPlaceholderConfig}
            />
          </View>
          <View
            style={styles.secondLineContainer}
            testID={FrameworkTestKeys.trayLoadingCardSecondLineView}
          >
            <Shimmer
              config={subTrayCardsLoadingConfig.secondLine}
              shimmerPlaceholderConfig={shimmerPlaceholderConfig}
            />
          </View>
          <View style={styles.circleContainer} testID={FrameworkTestKeys.trayLoadingCardCircleView}>
            <Shimmer
              config={subTrayCardsLoadingConfig.circle}
              shimmerPlaceholderConfig={shimmerPlaceholderConfig}
            />
          </View>
        </View>
      </View>
    );
    loadingCards.push(loadingCard);
  }

  return <View style={styles.cardContainer}>{loadingCards}</View>;
};

Loading.defaultProps = {
  subTrayCardsLoadingConfig: _subTrayCardsLoadingConfig,
  shimmerPlaceholderConfig: _shimmerPlaceholderConfig,
  theme: LightThemeColors,
};

Loading.propTypes = {
  subTrayCardsLoadingConfig: PropTypes.object,
  shimmerPlaceholderConfig: PropTypes.object,
  theme: PropTypes.object,
};

export default withTheme(Loading);
